var render = function (_h,_vm) {var _c=_vm._c;return _c('table',{staticClass:"info"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }